import { render, staticRenderFns } from "./ResultDocumentDetail.vue?vue&type=template&id=a4a3cc2e"
import script from "./ResultDocumentDetail.vue?vue&type=script&lang=js"
export * from "./ResultDocumentDetail.vue?vue&type=script&lang=js"
import style0 from "./ResultDocumentDetail.vue?vue&type=style&index=0&id=a4a3cc2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports